export const GET_INFORMATION_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    informationBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      body{
        json
          links {
            entries {
              hyperlink {
                ... on Page {
                  sys {
                    id
                  }
                  slug
                  content {
                    __typename
                  }
                }
                ... on FileBlock {
                  sys {
                    id
                  }
                  imageVaultFile
                  metaData
                  __typename
                }
              }
            }
          }
        }
      infoVariant
      linkReference {
        globalLinkItem
        url
        linkText
        variant
        reference {
          ...on Page {
            content {
              __typename
            }
            slug
          }
          ...on FileBlock
          {
            imageVaultFile
            __typename
          }
        }
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
    }
  }
`;
